<template>
    <div>
        <b-row>
            <b-col md="4">
                <div class="promotional_box">
                    <h3 class="mb-2">{{ promotionalData.toFixed(2) }}</h3>
                    <p class="mb-0">Promotional</p>
                </div>
            </b-col>
            <b-col md="4">
                <div class="akshayptra_box">
                    <h3 class="mb-2">{{ akshayPatraData.toFixed(2) }}</h3>
                    <p class="mb-0">Akshay Patra</p>
                </div>
            </b-col>
            <b-col md="4">
                <div class="cashback_box">
                    <h3 class="mb-2">{{ cashBack.toFixed(2) }}</h3>
                    <p class="mb-0">Cashback</p>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="9"></b-col>
            <b-col>
                <eb-select
                    class="select-background-white"
                    id="text"
                    type="text"
                    label="text"
                    :options="dateOption"
                    v-model="selectedDate"
                    :selected="selectedDate.text"
                    @input="changeDate"
                >
                </eb-select>
                <b-modal
                    title="Select Date"
                    header-class="header-nipige-class"
                    id="dateRange"
                    size="sm"
                    ref="date-range"
                    centered
                    hide-footer
                >
                    <b-input
                        class="mb-2"
                        type="date"
                        v-model="startDate"
                    ></b-input>
                    <b-input type="date" v-model="endDate"></b-input>
                    <div class="text-center mt-2">
                        <b-button
                            @click="findButtonClick()"
                            class="my -0 main-navigation-button w-47 mr-2"
                            variant="success"
                            >Find
                        </b-button>
                    </div>
                </b-modal>
            </b-col>
        </b-row>

        <div class="mt-4 text-center promotional_akshay_tab_div">
            <b-tabs pills v-model="tabIndex">
                <b-tab
                    @click="fetchAwardList('PROMOTIONAL')"
                    title="Promotional"
                    active
                    ><b-table
                        show-empty
                        header
                        :items="walletHistoryList"
                        head-variant="light"
                        class="border"
                    ></b-table
                ></b-tab>
                <b-tab
                    @click="fetchAwardList('AKSHAY_PATRA')"
                    title="Akshay Patra"
                    ><b-table
                        show-empty
                        header
                        :items="walletHistoryList"
                        head-variant="light"
                        class="border"
                    >
                        <template slot="cell(MoreInfo)" slot-scope="data">
                            <b-button
                                variant="info"
                                v-b-modal="`modal-${data.index}`"
                            >
                                <i class="fa fa-eye"></i
                            ></b-button>
                            <b-modal
                                :id="`modal-${data.index}`"
                                centered
                                ok-only
                            >
                                <h4>
                                    Reference Id :
                                    {{
                                        data && data.item && data.item.MoreInfo
                                            ? data.item.MoreInfo.referenceId
                                            : ""
                                    }}
                                </h4>
                                <h4>
                                    Txn Status :
                                    {{
                                        data && data.item && data.item.MoreInfo
                                            ? data.item.MoreInfo.txnStatus
                                            : ""
                                    }}
                                </h4>
                                <h4>
                                    Transfer Id :
                                    {{
                                        data && data.item && data.item.MoreInfo
                                            ? data.item.MoreInfo.transferId
                                            : ""
                                    }}
                                </h4>
                            </b-modal>
                        </template>
                    </b-table></b-tab
                >
                <b-tab @click="fetchAwardList('CASHBACK')" title="Cashback"
                    ><b-table
                        show-empty
                        header
                        :items="walletHistoryList"
                        head-variant="light"
                        class="border"
                    >
                        <template slot="cell(MoreInfo)" slot-scope="data">
                            <b-button
                                variant="info"
                                v-b-modal="`modal-${data.index}`"
                            >
                                <i class="fa fa-eye"></i
                            ></b-button>
                            <b-modal
                                :id="`modal-${data.index}`"
                                centered
                                ok-only
                            >
                                <h4>
                                    Reference Id :
                                    {{
                                        data && data.item && data.item.MoreInfo
                                            ? data.item.MoreInfo.referenceId
                                            : ""
                                    }}
                                </h4>
                                <h4>
                                    Txn Status :
                                    {{
                                        data && data.item && data.item.MoreInfo
                                            ? data.item.MoreInfo.txnStatus
                                            : ""
                                    }}
                                </h4>
                                <h4>
                                    Transfer Id :
                                    {{
                                        data && data.item && data.item.MoreInfo
                                            ? data.item.MoreInfo.transferId
                                            : ""
                                    }}
                                </h4>
                            </b-modal>
                        </template>
                    </b-table></b-tab
                >
            </b-tabs>
        </div>
    </div>
</template>

<script>
import ebSelect from "@/components/FormElements/Select.vue";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
    components: {
        ebSelect,
    },
    data() {
        return {
            tabIndex: 0,
            cashBack: 0,
            promotionalData: 0,
            akshayPatraData: 0,
            perPage: 7,
            currentPage: 1,
            filterCount: 0,
            selectedDate: {
                text: "Today",
                value: 1,
            },
            walletHistoryList: [],
            dateOption: [
                {
                    text: "Today",
                    value: 1,
                },
                {
                    text: "7 day's",
                    value: 7,
                },
                {
                    text: "30 day's",
                    value: 30,
                },
                {
                    text: "Custom",
                    value: "custom",
                },
            ],
            startDate: "",
            endDate: "",
        };
    },
    filters: {
        formatedate: function (value) {
            if (value) {
                return moment(String(value)).format("DD/MM/YYYY");
            }
        },
    },
    computed: {
        ...mapGetters({
            getAwardList: "customerManagement/GetAwardList",
            getAwardData: "customerManagement/GetAwardGraph",
        }),
        awardList() {
            return this.getAwardList;
        },
        getChartData() {
            const data = this.getAwardData;
            if (
                data &&
                data.response &&
                Array.isArray(data.response) &&
                data.response.length &&
                data.response[0].statistic
            ) {
                return data && data.response[0]
                    ? data.response[0].statistic
                    : 0;
            }
        },
    },
    methods: {
        onFilter(list) {
            this.filterCount = list.length;
            this.currentPage = 1;
        },
        findButtonClick() {
            let e = {
                fromDate: this.startDate,
                toDate: this.endDate,
            };
            this.$refs["date-range"].hide();
            if (this.tabIndex === 0) {
                this.fetchAwardList("PROMOTIONAL");
            }
            if (this.tabIndex === 1) {
                this.fetchAwardList("AKSHAY_PATRA");
            }
            if (this.tabIndex === 2) {
                this.fetchAwardList("CASHBACK");
            }
        },
        changeDate(e) {
            this.selectedDate = e;
            if (e.value == "custom") {
                this.$refs["date-range"].show();
                return;
            }
            if (this.tabIndex === 0) {
                this.fetchAwardList("PROMOTIONAL");
            }
            if (this.tabIndex === 1) {
                this.fetchAwardList("AKSHAY_PATRA");
            }
            if (this.tabIndex === 2) {
                this.fetchAwardList("CASHBACK");
            }
        },
        getDateData(dateData) {
            if (dateData == "custom") {
                const data = {
                    fromDate: this.startDate,
                    toDate: this.endDate,
                };
                return data;
            }
            if (dateData == 1) {
                const data = {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                return data;
            } else {
                const data = {
                    fromDate: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.fromDate = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        getDateData1(dateData) {
            if (dateData == "custom") {
                const data = {
                    from: this.startDate,
                    to: this.endDate,
                };
                return data;
            }
            if (dateData == 1) {
                const data = {
                    from: moment().format("YYYY-MM-DD"),
                    to: moment().format("YYYY-MM-DD"),
                };
                return data;
            } else {
                const data = {
                    from: moment().subtract(30, "days").format("YYYY-MM-DD"),
                    to: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.from = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        async fetchAwardList(type) {
            this.items = [];
            try {
                const payload = {
                    id: this.currentUser.id,
                    amountType: type,
                    ...this.getDateData1(this.selectedDate.value),
                };
                const data = await this.$store.dispatch(
                    "customerManagement/awardList",
                    payload,
                );
                this.walletHistoryList = (data || []).map((element) => {
                    const itemData = {
                        Date: moment(element.createdAt).format("DD/MM/YYYY"),
                        Type: element.amount < 0 ? "Debit" : "Credit",
                        Description: element.description,
                        Amount: `₹ ${element.amount.toFixed(2)}`,
                    };
                    if (element.meta) {
                        itemData.MoreInfo = element.meta;
                    }
                    return itemData;
                });
            } catch {
                this.items = [];
            }
        },
        async fetchChartData() {
            const payload = {
                customerId: this.currentUser.id,
            };
            const dataList = await this.$store.dispatch(
                "customerManagement/awardGraph",
                payload,
            );
            const walletData =
                (dataList &&
                    dataList.response &&
                    Array.isArray(dataList.response) &&
                    dataList.response.length &&
                    dataList.response[0].statistic) ||
                [];

            walletData.forEach((element) => {
                if (element.awardType === "PROMOTIONAL") {
                    return (this.promotionalData = element.awardValue);
                }
                if (element.awardType === "AKSHAY_PATRA") {
                    return (this.akshayPatraData = element.awardValue);
                }
                if (element.awardType === "CASHBACK") {
                    return (this.cashBack = element.awardValue);
                }
            });
        },
    },
    async mounted() {
        this.currentUser = this.$route.params;
        await this.fetchAwardList("PROMOTIONAL");
        await this.fetchChartData();
    },
};
</script>

<style scoped>
.promotional_box {
    background-image: linear-gradient(to right, #bddffd, #3893e6);
    padding: 14px 10px;
    border-radius: 8px;
}

.akshayptra_box {
    background-image: linear-gradient(to right, #ffedaf, #ffd12d);
    padding: 14px 10px;
    border-radius: 8px;
}

.cashback_box {
    background-image: linear-gradient(to right, #b6ffaf, #42ff2d);
    padding: 14px 10px;
    border-radius: 8px;
}

.promotional_akshay_tab_div .nav {
    display: inline-flex;
}

.select-background-white {
    background-color: #fff;
}

.award-boxes-row {
    align-items: stretch;
}

.award-filters-row {
    align-items: flex-end;
}

@media (max-width: 767.98px) {
    .promotional_box,
    .akshayptra_box,
    .cashback_box {
        padding: 12px 8px;
    }

    .promotional_box h3,
    .akshayptra_box h3,
    .cashback_box h3 {
        font-size: 1.5rem;
    }
}
</style>
